<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="normal"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      padding20
      @cancel="cancel"
      @confirm="confirm">
    <template #header>{{ title }}</template>
    <template #content>
      <el-form ref="form" :model="form" label-width="74px">
        <el-form-item :label="label"
                      prop="reason"
                      :rules="[{ required: true, message: '不能为空' ,trigger: ['blur', 'change']},
                               { max: 200, message: '长度不能大于200个字符', trigger: ['blur', 'change'] }]">
          <gj-textarea
              v-model="form.reason"
              :styles="{height: '120px', width: '100%'}"
              placeholder="不能超过两百个字符"
              class="form-input">
          </gj-textarea>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn} from "@/minxins";
import {purchasePlanPushAbolished, purchasePlanReviewNo} from "@/api/purchase";
import {defaultVal} from "@/utils/common";

export default {
  name: "app-product-plan-modal",
  mixins: [modalMixIn],
  props: {
    type: {
      required: true
    },
    rows: {
      required: true
    },
    title: {
      required: true
    },
    label: {
      required: true
    }
  },
  data() {
    return {
      confirmLoading: false,
      form: {
        reason: null
      }
    }
  },
  methods: {
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            idList: this.rows.map(v => v.purchasePlanId),
            reason: this.form.reason,
          };
          if (this.type === 'reject') {
            this.confirmLoading = true;
            purchasePlanReviewNo(params)
                .then(() => {
                  this.$emit('updated');
                  this.$gjDestroy();
                })
                .complete(() => this.confirmLoading = false);
          } else {
            purchasePlanPushAbolished(params)
                .then(() => {
                  this.$emit('updated');
                  this.$gjDestroy();
                })
                .complete(() => this.confirmLoading = false);
          }
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .el-form-item{
    margin-bottom: 0;
  }
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
</style>
